// cspell:ignore deckbuilding typal

/**
 * Concern:
 * Shared product/taxonomy brief for LLM prompt assembly and review exports.
 * Keeps runtime proposal generation and offline review aligned on the same
 * layer definitions, scope rules, and canonical-tag quality bar.
 */

export const TAXONOMY_PRODUCT_POLICY_BRIEF = `
Product:
- Turn owned MTG bulk into battle-ready Commander directions.
- The builder is advisory.
- Tags should improve discovery, commander selection, card ranking, and deck health guidance.

Taxonomy:
- Canonical tags are internal normalized semantics, not source labels.
- Use exactly three layers: FUNCTIONAL, TRIBAL, THEME.
- FUNCTIONAL: reusable mechanics or play patterns cards directly perform. Use for concrete behaviors, even when many archetypes use them.
- TRIBAL: explicit creature-type synergy only. Exclude generic type-changing, typal-adjacent mechanics, and broader card-type manipulation.
- THEME: stable Commander archetypes useful in discovery and commander selection. Exclude generic mechanic overlap, trigger buckets, and incidental or collection-local clusters better represented as FUNCTIONAL.
- Scope must match exemplar evidence. Do not narrow beyond the evidence or broaden mixed clusters into misleading archetypes or tribal concepts.
- Prefer NO_TAG over noisy, weak, redundant, misleading, or overly narrow concepts.
- Tags should be broad enough to matter, not so broad they become meaningless.
- Parent links must be same-layer strict subtype only. Never create cross-layer parents.
- New canonical tags may be proposed at runtime, but publication is human-reviewed.

Discovery intent:
- Prefer tags that expose reusable archetypes and hidden synergies from owned cards.
- If a concept is mostly a naming variant of a broader mechanic bucket, use the broader concept or NO_TAG.
- Ignore art, flavor, and print-only concepts.
`.trim();
